module.exports = __webpack_public_path__ + "img/timetolifeEN.d1156440.svg";